import React from "react";
import {Typography } from '@material-ui/core';
import FormScopeDefiner from "../../Component/Forms/FormScopeDefiner";
import PolicyImg    from "../../Component/PolicyImg";
import smsPolicyImg from '../../images/smspolicy.svg'
import useStyles    from '../../Component/ComponentCss';
import contextJson from './masterJson.json';

const apiContextVar = "qualityCheck";
const contextHeading = "Create Quality Check";

function Create(props) {
    // const [successRender,setSuccessRender] = React.useState(undefined);
    // const [successPageData,setSuccessPageData] = React.useState(undefined);
    let sideImageData={};
    const classes=useStyles();
    const contextClasses = classes.topSpace;
    const contextObjective = "create";
    const createClose=props.close;
    Object.keys(contextJson).forEach((key,index) =>{
      if(key!=="xioFEConfig"){
        contextJson[key].fields.map((field)=>{
          if(field.field_type==="custom"){
            field.field_value = "{}";
          } else if(field.field_type !== "hidden"&&field.field_default_value){
            field.field_value = field.field_default_value
            field.id = ""
          } else{
            field.field_value = "";
            field.field_helperText = "";
            field.id = "";
          }
          return field; // <-- add this return statement
        });
        
        // =---sideIMage---dataAssing--->
        if(contextJson['xioFEConfig']&&contextJson['xioFEConfig'].sideImageData){
          sideImageData=contextJson['xioFEConfig'].sideImageData;
        }
      }
    });


    return (
      <>
          {/* <PolicyImg Image={smsPolicyImg} data={sideImageData}/>  */}
          <div className={classes.formAline}>
            <Typography variant="h6" className={classes.marginChange}>
              {contextHeading}
            </Typography>
          <FormScopeDefiner value={{contextJson,apiContextVar,contextHeading,contextClasses,contextObjective,createClose}}>
          </FormScopeDefiner> 
          </div>
      </>
    )
  }

  export default Create;
  